import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { Label, Input, Select as SelectCF } from "~/componentes/CustomForm";
import { Colors } from "~/config/Colors";
import Select, { StylesConfig } from 'react-select';

import { Container } from "./styles";
import { Materialize } from "~/styles/materializeGrid";
import ShowConfirmacao from "~/utils/ShowConfirmacao";

function CreateEditContent({ mountedData, idUnidades, controle, unidades }) {
  const [ativo, setAtivo] = useState(!mountedData ? "true" : mountedData?.ativo ? "true" : "false");
  const [idsUnidades, setIdsUnidades] = useState(idUnidades);
  const [idUnidadesDefault, setIdUnidadesDefault] = useState([]);

  useEffect(() => {
    if (mountedData) {
      let lista = [];
      let lista2 = [];

      if (mountedData?.unidades?.length > 0) {
        for (const item of mountedData?.unidades) {
          lista.push({  value: item?.id, label: item?.nome, color: "#00B8D9"});
          lista2.push(item?.id);
        }
      }

      setIdUnidadesDefault(lista);
      setIdsUnidades(lista2);
    } else {
      setIdUnidadesDefault(unidades);
    }
  }, [mountedData, unidades]);
  
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === "true" ? true : false,
          idUnidades: idsUnidades,
        }
        let response;
        if (mountedData?.id)
          response = await api.put("/signed/cliente/gestorservico/gerenciamento/centroCusto", thisData);
        else
          response = await api.post("/signed/cliente/gestorservico/gerenciamento/centroCusto", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"} esse Centro de Custo, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"} esse Centro de Custo?`,
        successModal: `Centro de Custo ${mountedData?.id ? "atualizado" : "cadastrado"} com sucesso!`,
      }
    );
  }

  const colourStyles = {
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? Colors.Color2
          : undefined,
        color: Colors.Color7,
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : Colors.Color2
            : undefined,
        },
      };
    },
  };

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios</p>
        </div>
        <div className="row">
          <Label title="Codigo *" className="col s2 m2 l2">
            <Input name="codigo" defaultValue={mountedData?.codigo} required={true} />
          </Label>
          <Label title="Título *" className="col s8 m8 l8">
            <Input name="titulo" defaultValue={mountedData?.titulo} />
          </Label>
          <Label title="Ativo *" className="col s2 m2 l2">
            <SelectCF
              isString
              list={{ list: [{ id: "true", titulo: "Sim" }, { id: "false", titulo: "Não" }], value: "id", label: "titulo" }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={(e) => {
                const v = e.currentTarget.value || "true";
                setAtivo(v);
              }}
            />
          </Label>
        </div>
        <div className="row">
          {controle == "E" && (
            <Label title="Unidades *" className="col s12 m12 l12">
              <Select
                value={idUnidadesDefault}
                isMulti
                name="colors"
                options={unidades}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Unidades"
                onChange={(e) => {
                  let ids = [];
                  for (const itemE of e) {
                    ids.push(itemE?.value);
                  }
                  setIdsUnidades(ids);

                  let listaIdsUni = [];
                  
                  for (const item of e) {
                    const find = unidades.find((o) => o?.value == item?.value);
                    find && listaIdsUni.push(find);
                  }
            
                  setIdUnidadesDefault(listaIdsUni);
                }}
                styles={colourStyles}
              />
            </Label>
          )}
        </div>
        <div className="espaco-2"></div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
